module.exports = __webpack_public_path__ + "img/perspectives-slide04.e293f347.jpg";